import { BarChart3, Calculator, FileText, Receipt, Shield, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-10 border-b border-slate-100 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
          <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
            <Calculator className="h-8 w-8" />
            AI Accountant
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/dashboard" className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700">
              Go to dashboard
            </Link>
          </div>
        </div>
      </nav>

      <section className="mx-auto max-w-6xl px-4 py-16 text-center">
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm text-slate-600">
          <Shield className="h-4 w-4" />
          Built for Indian SMEs, CAs, and finance teams
        </div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
          Meet your new AI Accountant
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-600">
          Automate bookkeeping, GST reconciliation, and vendor bills — with production dashboards and
          Tally / Zoho-aware sync status.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/dashboard"
            className="rounded-xl bg-blue-600 px-6 py-3 font-semibold text-white shadow-lg hover:bg-blue-700"
          >
            Try demo dashboard
          </Link>
          <button
            type="button"
            className="rounded-xl border-2 border-blue-600 px-6 py-3 font-semibold text-blue-600 hover:bg-blue-50"
          >
            Schedule demo
          </button>
        </div>
      </section>

      <section className="border-t border-slate-100 bg-slate-50 py-16">
        <div className="mx-auto max-w-6xl px-4">
          <h2 className="text-center text-2xl font-bold text-slate-900">Product modules</h2>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            <Link
              to="/bookkeeping"
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-blue-300 hover:shadow-md"
            >
              <FileText className="h-10 w-10 text-blue-600" />
              <h3 className="mt-4 font-bold text-slate-900">Bookkeeping</h3>
              <p className="mt-2 text-sm text-slate-600">Statements, categorization, sync to Tally.</p>
            </Link>
            <Link
              to="/gst"
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-blue-300 hover:shadow-md"
            >
              <Calculator className="h-10 w-10 text-blue-600" />
              <h3 className="mt-4 font-bold text-slate-900">GST</h3>
              <p className="mt-2 text-sm text-slate-600">PR vs GSTR-2B matching and ITC insights.</p>
            </Link>
            <Link
              to="/bills"
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-blue-300 hover:shadow-md"
            >
              <Receipt className="h-10 w-10 text-blue-600" />
              <h3 className="mt-4 font-bold text-slate-900">Vendor bills</h3>
              <p className="mt-2 text-sm text-slate-600">OCR extraction and approval workflow.</p>
            </Link>
            <Link
              to="/dashboard"
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-blue-300 hover:shadow-md"
            >
              <BarChart3 className="h-10 w-10 text-blue-600" />
              <h3 className="mt-4 font-bold text-slate-900">Dashboards &amp; MIS</h3>
              <p className="mt-2 text-sm text-slate-600">P&amp;L, cash flow, AR/AP, GST summary.</p>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-6xl px-4 text-center">
          <Zap className="mx-auto h-10 w-10 text-amber-500" />
          <h2 className="mt-4 text-2xl font-bold text-slate-900">How it works</h2>
          <p className="mx-auto mt-2 max-w-2xl text-slate-600">
            Connect Tally or Zoho, upload documents, review AI suggestions, and sync — with full audit
            trails and reconciled-only dashboards.
          </p>
        </div>
      </section>
    </div>
  );
}
